import { AccountMarketingBlocks } from '@playbooks/components/account/account-marketing-blocks';
import { WorkspaceMenu } from '@playbooks/components/workspace/workspace-menu';
import { SheetFooter } from '@playbooks/ui/components/sheet';

const AppSlideFooter = ({ target = '' }) => {
	// Render
	return (
		<SheetFooter className='p-3'>
			<div className='flex-column gap-1 pb-2'>
				<AccountMarketingBlocks target={target} />
			</div>
			<WorkspaceMenu target={target} />
		</SheetFooter>
	);
};
export { AppSlideFooter };
